// extracted by mini-css-extract-plugin
module.exports = {"mobileMenu":"Header_mobileMenu__1DyKt","activeLink":"Header_activeLink__3RD42"};